import angular from 'angular';
import 'angular-i18n/angular-locale_hu-hu';
import common from '../../common/common';
import hirekMorzsamenu from '../../applications/hirek/hirek-reszletes/hirek-morzsamenu';
import kapcsolat from '../../applications/kapcsolat/kapcsolat';
import news from '../../modules/box/news';

angular.module('ANEW-app', [
	common,
	hirekMorzsamenu,
	kapcsolat,
	news
]).constant('environment', window.__env).config(function ($locationProvider) {
	'ngInject';
	$locationProvider.hashPrefix('');
});
angular.bootstrap(document, ['ANEW-app']);



// WEBPACK FOOTER //
// ./source/layouts/ANEW/layout.js